export const proSystemApiUrl = import.meta.env.VITE_FRONTEND_API_URL_REQUEST;

export const propassportURL = import.meta.env.VITE_PROPASSPORT_URL;
export const proSystemApiSSEUrl = import.meta.env.VITE_FRONTEND_API_NOTIFICATION;

export const proAnalyticURL = import.meta.env.VITE_PROANALYTIC_URL;
export const proMarketURL = import.meta.env.VITE_PROMARKET_URL;
export const f3ProURL = import.meta.env.VITE_F3PRO_URL;
export const proLearningURL = import.meta.env.VITE_PROLEARNING_URL;
